import { createAsyncThunk } from '@reduxjs/toolkit'
import { CommonClient } from '../types/Common'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'

export const fetchCommonClients = createAsyncThunk<
    Array<CommonClient>,
    void,
    ThunkConfig<string>
>('common/fetchCommonClients', async (_, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    try {
        const res = await api.get<Array<CommonClient>>('/common/clients')

        return res.data
    } catch (e) {
        console.log(e)
        appHandleError(e, 'fetchCommonData', 'Failed to fetch common data')
        return rejectWithValue('Error occurred ')
    }
})
